<cerrix-toggle-button class="toggle-accept" [active]="isAcceptActive()" (pressed)="select(true)"
    ><mat-icon class="cerrix-icon" svgIcon="check"></mat-icon
></cerrix-toggle-button>
<cerrix-toggle-button class="toggle-reject" [active]="isRejectActive()" (pressed)="select(false)"
    ><mat-icon class="cerrix-icon" svgIcon="close"></mat-icon
></cerrix-toggle-button>
